import {CreateOrderFormSnapshot, CreateOrderValidationResult} from './types'

export const validateCreateOrderForm = (form: CreateOrderFormSnapshot): CreateOrderValidationResult => {
  if (!form.customerId && (!form.firstName?.trim() || !form.lastName?.trim())) {
    return {valid: false, message: 'Please select a customer profile or provide a first and last name for a new profile.'}
  }

  if (!form.warehouseId) {
    return {valid: false, message: 'Please select a warehouse.'}
  }

  if (!form.channelSource) {
    return {valid: false, message: 'Please select an order source.'}
  }

  if (!form.orderStatus) {
    return {valid: false, message: 'Please select an order status.'}
  }

  const validLineItems = form.lineItems.filter(
    (item) => item.platform_product && item.platform_product_variant && item.quantity > 0
  )

  if (!validLineItems.length) {
    return {valid: false, message: 'Add at least one line item with a product variant and quantity.'}
  }

  const incompleteRow = form.lineItems.some(
    (item) =>
      (item.platform_product || item.platform_product_variant || item.name || item.sku) &&
      (!item.platform_product || !item.platform_product_variant)
  )

  if (incompleteRow) {
    return {valid: false, message: 'Each line item must have a product variant selected.'}
  }

  const missingPrice = form.lineItems.some(
    (item) => item.platform_product && (item.price === null || item.price === undefined || item.price === '' as any)
  )

  if (missingPrice) {
    return {valid: false, message: 'Each line item must have a valid Unit Price.'}
  }

  return {valid: true}
}
